const scrollCaptureMap = new Map<string, number>()

/** If captured scroll exists, is using manual scroll restoration */
export function hasScrollRestoreOverride(key: string) {
  return scrollCaptureMap.has(key)
}

export function getScrollRestoreOverride(key: string) {
  return scrollCaptureMap.get(key)
}

export function setScrollRestoreOverride(key: string, value: number) {
  scrollCaptureMap.set(key, value)
}

/** Only keep the last 10 scroll positions, clean up after 25 */
export function cleanUpScrollRestoreOverrideData() {
  if (scrollCaptureMap.size <= 25) return

  const scrollPositions = Array.from(scrollCaptureMap.entries()).reverse().slice(0, 10).reverse()
  scrollCaptureMap.clear()
  scrollPositions.forEach(([key, value]) => scrollCaptureMap.set(key, value))
}
